import { PublicKey } from "@solana/web3.js";
import DepthChart from "components/Secondary/DepthChart";
import { formatNumber } from "helpers/helpers";
import useWindowDimensions from "helpers/screen";
import { useEffect, useState } from "react";
import { GetMarket } from "utils/market";
import { GetOrderBookWithEvents } from "utils/orderbook";
import "./style.scss";
import { useSelector } from "react-redux";

const OrderBook = ({marketData, arrangement, setLimitPrice, setTradeAmount, setTotalAmount, setEventsQueue}) => {

  const state = useSelector((state) => state.storage);

  const [page, setPage] = useState(0);

  const {width} = useWindowDimensions();

  const [orderBook, setOrderBook] = useState([]);
  const [askTotals, setAskTotals] = useState([]);
  const [bidTotals, setBidTotals] = useState([]);
  const [market, setMarket] = useState();

  useEffect(() => {
    if(marketData) {
      setMarket(marketData.serumMarket)
    }
  },[marketData])

  useEffect(() => {
    let interval = setInterval(updateOrderbook, 2000);

    return () => clearInterval(interval);
  },[market])

  useEffect(() => {
    if(market) {
      GetOrderBookWithEvents(state.connection, market).then((response) => {
        let bids = response.bids;
        let asks = response.asks;
        let events = response.events;
        
        let _bidTotals = [];
        let _bidSum = 0;
        let _askSum = 0;
        let _askTotals = [];

        for(let i = 0; i < bids.length; i++) {
          let bid = parseFloat(bids[i][1]);
          _bidSum += bid;
          _bidTotals.push(_bidSum);
        }
        for(let i = 0; i < asks.length; i++) {
          let ask = parseFloat(asks[i][1]);
          _askSum += ask;
          _askTotals.push(_askSum);
        }
        setBidTotals(_bidTotals);
        setAskTotals(_askTotals);
        setOrderBook({
          bids: bids,
          asks: asks
        });
        setEventsQueue(events);
        if(bids[0])
          setLimitPrice(bids[0][0].toFixed(10))
      })
    }
    
  }, [market])


  function updateOrderbook() {
    if(state.connection && market) {
      GetOrderBookWithEvents(state.connection, market).then((response) => {
        let bids = response.bids;
        let asks = response.asks;
        let events = response.events;
        
        let _bidTotals = [];
        let _bidSum = 0;
        let _askSum = 0;
        let _askTotals = [];

        for(let i = 0; i < bids.length; i++) {
          let bid = parseFloat(bids[i][1]);
          _bidSum += bid;
          _bidTotals.push(_bidSum);
        }
        for(let i = 0; i < asks.length; i++) {
          let ask = parseFloat(asks[i][1]);
          _askSum += ask;
          _askTotals.push(_askSum);
        }
        setBidTotals(_bidTotals);
        setAskTotals(_askTotals);
        setOrderBook({
          bids: bids,
          asks: asks
        });
        setEventsQueue(events);
      })

    }
    else
    console.log("Orderbook not loaded, connection/market not set", state.connection, market)
  }

  if(width > 768)
  return <div className="orderBook disable-select" style={arrangement > 0 ? {borderLeft:"1px solid var(--gray0)"} : {borderRight:"1px solid var(--gray0)"} }>
    <div className="orderBookButtons">
      <div className={page === 0 ? "orderBookButton _selected":"orderBookButton"} onClick={() => setPage(0)}>
        Orderbook
      </div>
      <div className={page === 1 ? "orderBookButton _selected":"orderBookButton"} onClick={() => setPage(1)}>
        Depth
      </div>
    </div>

    {
      page === 1 &&
      <div className="orderBookContainer chartWrapper">
        <DepthChart orderbook={orderBook} totalBids={bidTotals} totalAsks={askTotals}/>
      </div>
    }
    
    
    { page === 0 && orderBook.asks && orderBook.bids &&
      <div className="orderBookContainer">
        <div className="orderBookTop">
          <div className="orderBookTitle"><p className="title">Price</p><p className="tickerWrapper">{(marketData.pairs && marketData.pairs.quote) ?(marketData.pairs.quote.symbol || "UNKNOWN") : "UNKNOWN"}</p></div>
          <div className="orderBookTitle"><p className="title">Size</p><p className="tickerWrapper">{(marketData.pairs && marketData.pairs.base) ? (marketData.pairs.base.symbol || "UNKNOWN") : "UNKNOWN"}</p></div>
          <div className="orderBookTitle"><p className="title">Total</p><p className="tickerWrapper">{(marketData.pairs && marketData.pairs.base) ? (marketData.pairs.base.symbol || "UNKNOWN") : "UNKNOWN"}</p></div>
        </div>

        <div className="ordersWrapper">
          <div className="ordersSide" style={{flexDirection: "column-reverse"}}>
            { orderBook.asks &&
              orderBook.asks.map((item, i) => {
                return <div className="orderTile disable-select" key={i}>
                  <div className="orderSizeBar" style={{width: (item[1] / askTotals[askTotals.length-1]) * 100 + "%", opacity:0.4, backgroundColor: "var(--red700)"}}></div>
                  <div className="orderSizeBar total" style={{width: (askTotals[i] / askTotals[askTotals.length-1]) * 100 + "%", backgroundColor: "var(--red700)"}}></div>
                  <div className="orderTileInner">
                    <p className="title" onClick={() => setLimitPrice(item[0])}>{formatNumber(item[0],8)}</p>
                    <p className="title" onClick={() => setTradeAmount(item[1])}>{formatNumber(item[1],8)}</p>
                    <p className="title">{formatNumber(askTotals[i],2)}</p>
                  </div>
                </div>
              })
            }
          </div>
          { (orderBook.bids && orderBook.bids.length > 0) ?
            <div className="currentPrice" onClick={() => setLimitPrice(orderBook.bids[0][0])}>
              <p className="price">{formatNumber(parseFloat(orderBook.bids[0][0]),10)}</p>
              <p className="priceUSD">${formatNumber(parseFloat(orderBook.bids[0][0]),10)}</p>
            </div>
            :
            <div className="currentPrice">
              <p className="price">{formatNumber(0,10)}</p>
              <p className="priceUSD">${formatNumber(0,10)}</p>
            </div>
          }
          <div className="ordersSide">
          { orderBook.bids &&
              orderBook.bids.map((item, i) => {
                return <div className="orderTile disable-select" key={i}>
                  <div className="orderSizeBar" style={{width: (item[1] / bidTotals[bidTotals.length-1]) * 100 + "%",  opacity:0.4,backgroundColor: "var(--green700)"}}></div>
                  <div className="orderSizeBar total" style={{width: (bidTotals[i] / bidTotals[bidTotals.length-1]) * 100 + "%", backgroundColor: "var(--green700)"}}></div>
                  <div className="orderTileInner">
                    <p className="title" onClick={() => setLimitPrice(item[0])}>{formatNumber(item[0],8)}</p>
                    <p className="title" onClick={() => setTradeAmount(item[1])}>{formatNumber(item[1],8)}</p>
                    <p className="title">{formatNumber(bidTotals[i],2)}</p>
                  </div>
                </div>
              })
            }
          </div>
        </div>
      </div>
    }
    
  </div>

  if(width <= 768) // mobile view
  return <div className="orderBookMobile disable-select">
    <div className="orderBookButtons">
      <div className={page === 0 ? "orderBookButton _selected":"orderBookButton"} onClick={() => setPage(0)}>
        Orderbook
      </div>
      <div className={page === 1 ? "orderBookButton _selected":"orderBookButton"} onClick={() => setPage(1)}>
        Trades
      </div>
    </div>


    { page === 0 &&
      <div className="orderBookContainer">
        <div className="orderBookTop">
          <div className="orderBookTitle"><p className="title">Price</p><p className="tickerWrapper">{marketData.pairs && marketData.pairs.quote.symbol}</p></div>
          <div className="orderBookTitle"><p className="title">Size</p><p className="tickerWrapper">{marketData.pairs && marketData.pairs.base.symbol}</p></div>
        </div>

        <div className="ordersWrapper">
          <div className="ordersSide" style={{flexDirection: "column-reverse"}}>
            
            { orderBook.asks &&
              orderBook.asks.map((item, i) => {
                return <div className="orderTile disable-select" key={i}>
                  <div className="orderSizeBar" style={{width: (item[1] / askTotals[askTotals.length-1]) * 100 + "%", opacity:0.4, backgroundColor: "var(--red700)"}}></div>
                  <div className="orderSizeBar total" style={{width: (askTotals[i] / askTotals[askTotals.length-1]) * 100 + "%", backgroundColor: "var(--red700)"}}></div>
                  <div className="orderTileInner">
                    <p className="title" onClick={() => setLimitPrice(item[0])}>{formatNumber(item[0],4)}</p>
                    <p className="title" onClick={() => setTradeAmount(item[1])}>{formatNumber(item[1],4)}</p>
                  </div>
                </div>
              })
            }
          </div>
          { (orderBook.bids && orderBook.bids.length > 0) ?
            <div className="currentPrice" onClick={() => setLimitPrice(orderBook.bids[0][0])}>
              <p className="price">{formatNumber(parseFloat(orderBook.bids[0][0]),6)}</p>
              <p className="priceUSD">${formatNumber(parseFloat(orderBook.bids[0][0]),6)}</p>
            </div>
            :
            <div className="currentPrice">
              <p className="price">{formatNumber(0,6)}</p>
              <p className="priceUSD">${formatNumber(0,6)}</p>
            </div>
          }
          <div className="ordersSide">
            { orderBook.bids &&
              orderBook.bids.map((item, i) => {
                return <div className="orderTile disable-select" key={i}>
                  <div className="orderSizeBar" style={{width: (item[1] / bidTotals[bidTotals.length-1]) * 100 + "%",  opacity:0.4,backgroundColor: "var(--green700)"}}></div>
                  <div className="orderSizeBar total" style={{width: (bidTotals[i] / bidTotals[bidTotals.length-1]) * 100 + "%", backgroundColor: "var(--green700)"}}></div>
                  <div className="orderTileInner">
                    <p className="title" onClick={() => setLimitPrice(item[0])}>{formatNumber(item[0],4)}</p>
                    <p className="title" onClick={() => setTradeAmount(item[1])}>{formatNumber(item[1],4)}</p>
                  </div>
                </div>
              })
            }
          </div>
        </div>
      </div>
    }
    
  </div>
}

export default OrderBook;